import { collection, getDocs, query, runTransaction } from 'firebase/firestore';
import { db } from '@/firebase';
import { getTenantCollectionPath } from '../utils/firebase';

async function updateOptionInProducts(id, optionData) {
	await runTransaction(db, async (transaction) => {
		const productsRef = collection(db, getTenantCollectionPath('products'));
		const snapshot = await getDocs(productsRef);

		if (!snapshot.empty) {
			snapshot.docs.forEach((productDoc) => {
				const productData = productDoc.data();
				let hasUpdates = false;

				// Check if product has variants with options that reference this option
				if (productData.variants && Array.isArray(productData.variants)) {
					const updatedVariants = productData.variants.map((variant) => {
						if (variant.options && Array.isArray(variant.options)) {
							const updatedOptions = variant.options.map((option) => {
								if (option.id == id) {
									hasUpdates = true;
									return {
										...option,
										name: optionData.name,
									};
								}
								return option;
							});

							if (hasUpdates) {
								return {
									...variant,
									options: updatedOptions,
								};
							}
						}
						return variant;
					});

					if (hasUpdates) {
						transaction.update(productDoc.ref, {
							variants: updatedVariants,
							updatedAt: new Date(),
						});
					}
				}

				// Check if product has options directly referenced
				if (productData.options && Array.isArray(productData.options)) {
					const hasOptionReference = productData.options.some((option) => option.id == id);

					if (hasOptionReference) {
						const updatedOptions = productData.options.map((option) => {
							if (option.id == id) {
								return {
									...option,
									name: optionData.name,
								};
							}
							return option;
						});

						transaction.update(productDoc.ref, {
							options: updatedOptions,
							updatedAt: new Date(),
						});
					}
				}
			});
		}
	});
}

export class OptionFunctions {
	static async updateOption(id, optionData) {
		await updateOptionInProducts(id, optionData);
	}
}
